import { render } from "./ExpenseForm.vue?vue&type=template&id=3e60e921&scoped=true"
import script from "./ExpenseForm.vue?vue&type=script&lang=js"
export * from "./ExpenseForm.vue?vue&type=script&lang=js"

import "./ExpenseForm.vue?vue&type=style&index=0&id=3e60e921&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e60e921"]])

export default __exports__